import React from "react";
import {CloseButton, Modal } from "react-bootstrap";

function RecommendationModal({
  isModalVisible,
  setIsModalVisible,
  mappedData,
  firstMonth,
}) {
  return (
    <div>
      <Modal
        show={isModalVisible}
        onHide={() => setIsModalVisible(false)}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        style={{ zIndex: "99999999", marginTop: "7rem" }}
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            {firstMonth ? "One Month Kit" : "Three Month kit"}
          </Modal.Title>
          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={() => setIsModalVisible(false)}
          />
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column" style={{ zIndex: "999" }}>
            {mappedData?.map((item) => {
              return (
                <div className="d-flex justify-content-between border p-2">
                  <div className="text-black text-black fw-bold">
                    {item?.name}{" "}
                  </div>
                  <div className="text-secondary text-black fw-bold">
                    {item?.quantity}
                  </div>
                </div>
              );
            })}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default RecommendationModal;

